module.exports = __webpack_public_path__ + "files/8c4a6ba94f89cb5006f5c69713293539.png";